import { ProposalGalleryResponse } from "services/proposal";
import { cdnUrl } from 'constants/generic';

export const getBlobUrl = () => `${cdnUrl}/backend/s3/prod.beprotravel/cdn/`;

export const normalizeCityName = (value: string) =>
  value.trim().toLowerCase().replace(/[^a-z]/g, '');

export const getCityGalleryUrls = (
  companyGallery: Record<string, string[]> | undefined,
  city?: string,
): string[] => {
  if (!companyGallery || !city?.trim()) {
    return [];
  }

  const normalizedCity = normalizeCityName(city);
  if (!normalizedCity) {
    return [];
  }

  const urls = Object.entries(companyGallery)
    .filter(([key]) => {
      const normalizedKey = normalizeCityName(key);
      if (!normalizedKey) {
        return false;
      }
      return normalizedKey.includes(normalizedCity) || normalizedCity.includes(normalizedKey);
    })
    .flatMap(([, galleryUrls]) => galleryUrls);

  return Array.from(new Set(urls.filter(Boolean)));
};

export const mergeProposalGalleryUrls = (
  response: Pick<ProposalGalleryResponse, 'userGallery' | 'companyGallery'>,
  city?: string,
): string[] => {
  const cityGallery = getCityGalleryUrls(response.companyGallery, city);
  const userGallery = response.userGallery || [];

  return Array.from(new Set([...cityGallery, ...userGallery].filter(Boolean)));
};

export const resolveGalleryImageUrl = (blobUrl: string, url: string) => {
  if (!url) {
    return '';
  }
  if (url.startsWith('http') || url.startsWith('data:')) {
    return url;
  }
  return blobUrl.replace('/cdn', '') + url;
};

export const resolveUploadedImageUrl = (response: unknown): string | undefined => {
  if (!response) {
    return undefined;
  }
  if (typeof response === 'string') {
    return response;
  }
  if (typeof response !== 'object') {
    return undefined;
  }
  const data = response as Record<string, unknown>;
  const candidates = [data.url, data.fileUrl, data.link, data.path, data.imageUrl, data.fileName];
  return candidates.find((value) => typeof value === 'string' && value.length > 0) as
    | string
    | undefined;
};


export const getDefaultCityGalleryImage = (city?: string): string | undefined => {
  try {
    const cached = sessionStorage.getItem('proposalGallery');
    if (!cached) {
      return undefined;
    }
    const data = JSON.parse(cached) as ProposalGalleryResponse;
    if (data.hasErrors) {
      return undefined;
    }
    return getCityGalleryUrls(data.companyGallery, city)[0];
  } catch {
    return undefined;
  }
};